import React from "react";
import { NoData } from "../../../../../components";

const NodataList = () => {
  return (
    <div className="flex-1 flex">
      <NoData />
    </div>
  );
};

export default NodataList;
